import bankAccountsImage from "../assets/images/bank_accounts_image.png";
import credentialsImage from "../assets/images/credentials_image.jpg";
import pmsImage from "../assets/images/pms_image.jpg";
import propertiesImage from "../assets/images/properties_image.jpg";
import teamImage from "../assets/images/team_image.jpg";

export enum CallToActionType {
    Modal = "modal",
    Path = "path",
}

export type OnboardingStep = {
    step_code: string;
    image_path: string | null;
    video_path: string | null;
    title: string;
    description: string;
    success_message: string;
    main_call_to_action_text: string;
    main_call_to_action_type: CallToActionType | null;
    main_call_to_action_string: string | null;
    is_skippable: boolean;
};

export const ONBOARDING_STEPS: OnboardingStep[] = [
    {
        step_code: "PMS",
        image_path: pmsImage,
        video_path: "NpEaa2P7qZI", // placeholder video ID
        title: "Connect Your PMS",
        description: "Link your Property Management System to sync data automatically",
        success_message: "PMS Connected Successfully",
        main_call_to_action_text: "Connect PMS",
        main_call_to_action_type: CallToActionType.Modal,
        main_call_to_action_string: "connect-pms-modal",
        is_skippable: false,
    },
    {
        step_code: "PROPERTIES",
        image_path: propertiesImage,
        video_path: "NpEaa2P7qZI", // placeholder video ID
        title: "Confirm Properties",
        description: "Review properties",
        success_message: "Properties Scope Confirmed",
        main_call_to_action_text: "Confirm Properties",
        main_call_to_action_type: CallToActionType.Path,
        main_call_to_action_string: "/config?config-tab=properties",
        is_skippable: true,
    },
    {
        step_code: "BANK_ACCOUNTS",
        image_path: bankAccountsImage,
        video_path: "NpEaa2P7qZI", // placeholder video ID
        title: "Confirm Bank Accounts",
        description: "Review bank accounts",
        success_message: "Bank Accounts Scope Confirmed",
        main_call_to_action_text: "Review Accounts",
        main_call_to_action_type: CallToActionType.Path,
        main_call_to_action_string: "/config?config-tab=bank-accounts",
        is_skippable: true,
    },
    {
        step_code: "CREDENTIALS",
        image_path: credentialsImage,
        video_path: "NpEaa2P7qZI", // placeholder video ID
        title: "Add Credentials",
        description:
            "Store login credentials for property-related services. You can add these later if you don’t have them now",
        success_message: "Credentials Confirmed",
        main_call_to_action_text: "Add Credentials",
        main_call_to_action_type: CallToActionType.Path,
        main_call_to_action_string: "/config?config-tab=credentials",
        is_skippable: true,
    },
    {
        step_code: "TEAMS",
        image_path: teamImage,
        video_path: "NpEaa2P7qZI", // placeholder video ID
        title: "Invite Your Team",
        description: "Add team members who need access to your account",
        success_message: "Team Confirmed",
        main_call_to_action_text: "Invite Team",
        main_call_to_action_type: CallToActionType.Path,
        main_call_to_action_string: "/config?config-tab=team",
        is_skippable: true,
    },
    {
        step_code: "OPEN_ITEMS",
        image_path: null,
        video_path: "NpEaa2P7qZI", // placeholder video ID
        title: "Welcome to Open Items!",
        description:
            "This is your Open Items dashboard where you'll track outstanding accounting tasks and action items. As your accountants work through monthly close, reconciliations, and other processes, any items that need attention will appear here for you to review and resolve.",
        success_message: "Onboarding Completed",
        main_call_to_action_text: "Got it",
        main_call_to_action_type: null,
        main_call_to_action_string: null,
        is_skippable: false,
    },
];

export default ONBOARDING_STEPS;
